import { Ansokan, AnsokanServiceInterface } from './AnsokanServiceInterface';
import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { StatisticsService } from '@exp/vue';
import { APP_ENTRY_POINT_URL } from '@/constants';
// Do not export the implemention class.
// A service shall implement an interface with
// the exposed methods.
export class AnsokanServiceImpl implements AnsokanServiceInterface {
    public ANSOKANENDPOINT = '/fk_apps/FMIBestallIntygREST/public/v1/bestall';
    public client: AxiosInstance;

    constructor() {
        this.client = axios.create();
        this.client.defaults.params = {
            kanal: 2,
        };
        this.client.defaults.timeout = 10000;
    }

    abort(): void {
        window.sessionStorage.clear();
        StatisticsService.applicationAborted();
        window.location.href = APP_ENTRY_POINT_URL;
    }

    /**
     * Post ansökan to REST-service.
     */
    public async submit(ansokan: Ansokan): Promise<AxiosResponse> {
        // OBS! använd färdigt npm-paket https://npm.repo.sfa.se/service/rest/repository/browse/FK-NPM-INTERN/api-formansintyg/
        const body = {
            pnr: ansokan.pnr.replace('-', ''),
        };
        return this.client.post(this.ANSOKANENDPOINT, body, this.client.defaults);
    }

    private async sleep(n: number): Promise<void> {
        return new Promise((resolve) => setTimeout(resolve, n));
    }
}

// Export a single instance of the service (singleton pattern).
export const AnsokanService = new AnsokanServiceImpl();
